export default "__VITE_ASSET__BpEvdBjL__"